'use client';

import { useAtomValue } from 'jotai';
import { Suspense, lazy } from 'react';

import { complimentaryTrialEndModalEntryPointAtom } from './complimentary-trial-end-atoms';
import type { ComplimentaryTrialEndModalPorts } from './complimentary-trial-end-modal.types';

// `React.lazy`, not `next/dynamic`: this zone admits no `next/*` import.
const ComplimentaryTrialEndModalImplementation = lazy(() =>
  import('./complimentary-trial-end-modal-implementation').then((module) => ({
    default: module.ComplimentaryTrialEndModalImplementation,
  }))
);

/** T-7 upgrade modal for the end of complimentary Max usage, opened from the sidebar or banner. */
export function ComplimentaryTrialEndModal({
  ports,
}: {
  ports: ComplimentaryTrialEndModalPorts;
}) {
  const isOpen = useAtomValue(complimentaryTrialEndModalEntryPointAtom) != null;
  if (!isOpen) return null;

  return (
    <Suspense fallback={null}>
      <ComplimentaryTrialEndModalImplementation ports={ports} />
    </Suspense>
  );
}
